module.exports = __webpack_public_path__ + "img/icon-lego-community.7bbdd43e.svg";